import { useEffect, useState } from "react";
import { X } from "lucide-react";

const useKeyboardOffset = (active) => {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!active || !vv) return undefined;
    const update = () => setOffset(Math.max(0, window.innerHeight - vv.height - vv.offsetTop));
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, [active]);
  return offset;
};

export const BottomSheet = ({ open, onClose, title, children, testid }) => {
  const offset = useKeyboardOffset(open);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50" role="dialog" aria-modal="true" aria-label={title} data-testid={testid}>
      <button type="button" aria-label="Close" data-testid={`${testid}-backdrop`} onClick={onClose} className="absolute inset-0 bg-slate-900/40" />
      <div style={{ bottom: offset }} className="sheet-up absolute inset-x-0 mx-auto max-h-[85dvh] max-w-lg overflow-y-auto rounded-t-3xl bg-white px-5 pt-3 shadow-2xl pb-[max(1.25rem,env(safe-area-inset-bottom))]">
        <div className="mx-auto mb-3 h-1.5 w-10 rounded-full bg-slate-200" />
        <div className="mb-4 flex items-center justify-between gap-3">
          <h2 className="font-display text-xl font-extrabold tracking-tight text-slate-900">{title}</h2>
          <button type="button" aria-label="Close" data-testid={`${testid}-close`} onClick={onClose} className="flex h-10 w-10 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100">
            <X className="h-5 w-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const sheetInput = "h-12 w-full rounded-xl border border-slate-200 bg-white px-4 text-base text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-700";

export const scrollFieldIntoView = (e) => {
  const el = e.target;
  setTimeout(() => el.scrollIntoView({ block: "center", behavior: "smooth" }), 300);
};
